<template>
  <span class="quoteActionsButtonWrapper">
    <app-button
      v-if="visible"
      data-qa="send-sales-order-button"
      :disabled="disabled"
      class="quoteActionsButton"
      @click="
        checkSaveQuoteChecks(SaveQuoteCheckType.checkCustomerType, true) &&
        toggleSendOrderModal(true)
      "
    >
      {{
        salesApprovalEnabled
          ? i18n.t('/quoteactions/buttons/sendforapproval')
          : i18n.t('/QuoteActions/RequestSalesOrderButton')
      }}
    </app-button>

    <modal
      v-if="showSendOrderModal"
      :title="requestSalesOrderTitle"
      @close="toggleSendOrderModal(false)"
    >
      <sales-order-form @close="toggleSendOrderModal(false)" @signing-locally="signingLocally" />
    </modal>
    <customer-type-prompt
      :show="showCustomerTypePrompt"
      @confirm="
        checkSaveQuoteChecks(SaveQuoteCheckType.checkExpireDate, true) && toggleSendOrderModal(true)
      "
      @close="showCustomerTypePrompt = false"
    />
    <expire-date-prompt
      :show="showExpireDatePrompt"
      @confirm="
        checkSaveQuoteChecks(SaveQuoteCheckType.checkExpectedDeliveryDate, true) &&
        toggleSendOrderModal(true)
      "
      @close="showExpireDatePrompt = false"
    />
    <expected-delivery-date-prompt
      :show="showExpectedDeliveryDatePrompt"
      :hide-buttons="true"
      @confirm="toggleSendOrderModal(true)"
      @close="showExpectedDeliveryDatePrompt = false"
    />
  </span>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import SalesOrderForm from '@/components/generic/presentational/organisms/quoteActions/SalesOrderForm.vue'
import { mapState, mapGetters } from 'vuex'
import CustomerTypePrompt from '@/components/generic/presentational/molecules/customerTypePrompt/CustomerTypePrompt.vue'
import CheckSaveQuote from '@/mixins/checkSaveQuote.js'
import SaveQuoteCheckType from '@/helpers/enums/saveQuoteCheckType'
import ExpireDatePrompt from '@/components/generic/presentational/molecules/expireDatePrompt/ExpireDatePrompt.vue'
import ExpectedDeliveryDatePrompt from '@/components/generic/presentational/molecules/expectedDeliveryDatePrompt/ExpectedDeliveryDatePrompt.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'

export default {
  components: {
    AppButton,
    Modal,
    SalesOrderForm,
    CustomerTypePrompt,
    ExpireDatePrompt,
    ExpectedDeliveryDatePrompt,
  },
  mixins: [CheckSaveQuote, AdditionalOrder],
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showSendOrderModal: false,
      SaveQuoteCheckType,
      signingLocallyValue: false,
    }
  },
  computed: {
    ...mapState({
      quote(state, getters) {
        return getters[this.quoteNamespace + '/get']
      },
      isStockOrder(state, getters) {
        return getters[this.quoteNamespace + '/isStockOrder']
      },
      isSalesOrder(state, getters) {
        return getters[this.quoteNamespace + '/quoteStatusIsSalesOrder']
      },
    }),
    ...mapGetters({
      dealerSettings: 'user/dealerSettings',
    }),
    salesApprovalEnabled() {
      return !!this.dealerSettings?.salesApprovalEnabled
    },
    requestSalesOrderTitle() {
      // TODO: change hardcoded text
      return this.signingLocallyValue
        ? 'Lokaal ondertekenen'
        : this.i18n.t('/QuoteActions/Forms/RequestSalesOrderTitle')
    },
  },
  methods: {
    toggleSendOrderModal(show) {
      this.showSendOrderModal = show
    },
    signingLocally(signingLocally) {
      this.signingLocallyValue = signingLocally
    },
  },
}
</script>

<style lang="scss" scoped>
.quoteActionsButton {
  margin-bottom: 0;
}
</style>
